<template>
  <div>
    <!-- <h1 class="mobiTitle white lg content" id="contentTitle">
      {{ $t('profile') }}
    </h1> -->
    <div class="profileImg">
      <div class="userAccount">
        <div class="userAccount__image">
            <img class="user_img" src="../../assets/gameonz/imgs/dummy_account.jpeg"/>
        </div>
        <div class="userAccount__name">
            <h1 class="mobiTitle md">{{$t("hello")}}</h1>
        </div>
      </div>
    </div>
    <div class="main_wrap">
      <div class="mobiSection">
        <div class="mobiSection__content">
          <div class="userProfile">
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('registered_num') }}:</label>
              <h2 class="mobiTitle md text_color">{{msisdn_gonz}}</h2>
            </div>
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('subscription_date') }}:</label>
              <h2 class="mobiTitle md text_color">{{subscription_date_gonz}}</h2>
            </div>  
            <div class="inputWrap">
              <label for="" class="inputWrap__label text_color">{{ $t('next_renew_date') }}:</label>
              <h2 class="mobiTitle md text_color">{{renew_date_gonz}}</h2>
            </div>
          </div>
          <div class="btnContainer " v-if="authentication_gonz === 'loggedin'">
            <div>
              <a @click="logout_gonz(is_unsub_gonz)" class="mobiBtn">{{ $t("unsubscribe") }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: mapGetters([
    "msisdn_gonz",
    "renew_date_gonz",
    "subscription_date_gonz",
    "authentication_gonz",
    "is_unsub_gonz"
  ]),
  methods: {
    ...mapActions(["logout_gonz"])
  }
};
</script>

<style scoped lang="scss">
.profileImg {
  margin-bottom: 3rem;
  text-align: center;
  .mobiTitle {
    color: #fff;
  }
}
.userAccount__image {
  width: 92px;
  height: 92px;
  position: relative;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 50%;
  img {
    width: 100%;
  }
}
.userAccount__name {
  p {
    color: #000;
  }
  margin-top: 15px;
}
.inputWrap {
  label {
    color: #01af58;
    font-weight: 600;
  }
}
.ar_layout {
  .userAccount__name .mobiTitle {
    text-align: center;
  }
  .inputWrap {
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/gameonz/Profile.vue